import React from 'react';

export const ContentCollectionLazy = React.lazy(
  () => import('../ContentCollection/ContentCollectionPage')
);
